import { ReactElement } from 'react';
import './FormNotification.scss';

type FormNotificationProps = {
    children: React.ReactNode;
};

function FormNotification({ children }: FormNotificationProps): ReactElement | null {
    return <div className={'FormNotificationWrapper'}>{children}</div>;
}

export default FormNotification;
